const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_cf96b25e-09f4-49ff-9864-78d6b526484e/artifacts/tmakww7y_Sem%20fundo%20cor%20do%20manto%20de%20Nossa%20Senhora%20.png";

export function Logo({ className = "h-10", withText = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img src={LOGO_URL} alt="Alliance 4 Growth" className={`${className} w-auto object-contain`} />
      {withText && (
        <span className="font-heading font-extrabold tracking-tight text-lg leading-none">
          <span className="text-white">ALLIANCE</span>{" "}
          <span className="text-brand-blue">4</span>{" "}
          <span className="text-brand-orange">GROWTH</span>
        </span>
      )}
    </div>
  );
}

export { LOGO_URL };
